/** Fallback when Contentful config is missing or invalid. */
export const DEFAULT_EMIRATES_ID_OTP_RESEND_SECONDS = 120;

/**
 * Locales entry in the **auth** namespace (`content_type=locales`, type → auth).
 * Short text value: seconds until "Resend OTP" is enabled, e.g. `"120"`.
 */
export const CONTENTFUL_LOCALES_AUTH_KEY_EMIRATES_ID_OTP_RESEND_SECONDS =
  'emiratesIdOtpResendSeconds';

const MIN_SECONDS = 1;
const MAX_SECONDS = 600;

function coerceOtpResendSecondsText(value: unknown): string | null {
  if (value == null || value === '') {
    return null;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(Math.trunc(value));
  }
  return null;
}

export function parseEmiratesIdOtpResendSeconds(value: unknown): number {
  const text = coerceOtpResendSecondsText(value);
  if (text == null) {
    return DEFAULT_EMIRATES_ID_OTP_RESEND_SECONDS;
  }
  const parsed = Number.parseInt(text, 10);
  if (!Number.isFinite(parsed) || parsed < MIN_SECONDS || parsed > MAX_SECONDS) {
    return DEFAULT_EMIRATES_ID_OTP_RESEND_SECONDS;
  }
  return parsed;
}
